import styled from 'styled-components';
import { Spacer, mediaMinWidth, ComplementaryColor, BackgroundColor, ColorMode } from '@lux/core';
import { Title } from '@lux/title';
import { Text } from '@lux/text';

export const EAUpcomingCarouselContainer = styled.div`
    display: flex;
    flex-direction: column;
    margin-bottom: ${Spacer.M};

    ${mediaMinWidth.sm} {
        flex-direction: row;
    }
`;

export const DetailsWrapper = styled.div`
    background-color: ${({ theme }) => (theme.colorMode === ColorMode.DARK ? '#1a1a1a' : '#000')};
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    position: relative;
    padding: ${Spacer.M} ${Spacer.SM};
    gap: ${Spacer.M};

    ${mediaMinWidth.sm} {
        max-width: 350px;
        padding: ${Spacer.M} ${Spacer.L};
    }
`;

export const TierPillSection = styled.div`
    width: 100%;
    margin-left: -2px;

    ${mediaMinWidth.sm} {
        padding: 0;
    }
`;

export const TierPillWrapper = styled.div`
    display: flex;
    gap: 4px;
    align-items: center;
`;

export const HeadlineSection = styled.div`
    display: none;

    ${mediaMinWidth.sm} {
        display: block;
        width: 100%;
    }
`;

export const TimerSection = styled.div`
    width: 100%;

    ${mediaMinWidth.sm} {
        padding-bottom: ${Spacer.S};
    }
`;

export const DetailsContainer = styled.div`
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    width: 100%;
    gap: ${Spacer.M};
`;

export const EarlyAccessLabel = styled.span`
    color: #ffffff;
    font-size: 14px;
    font-weight: 400;
    line-height: 21px;
`;

export const UpcomingHeadline = styled(Title)`
    color: #ffffff;
    width: 100%;
    margin: 0;
`;

export const StartsOnLabel = styled(Text)`
    color: #ffffff;
`;

export const CountdownTimer = styled(Text)`
    color: #ffffff;
    display: block;
`;

export const StyledHeadline = styled(Title)`
    width: 100%;
    margin: 0;
    color: #ffffff;
`;

export const SeeAllButton = styled.a`
    font-family: 'Zalando Sans', sans-serif;
    font-size: 16px;
    font-weight: 700;
    line-height: 24px;
    color: ${ComplementaryColor.neonFresh};
    text-decoration: none;
    cursor: pointer;
    background: none;
    border: none;
    padding: 0;
    display: inline-block;
    position: relative;

    &::after {
        content: '';
        position: absolute;
        bottom: 0;
        left: 0;
        width: 100%;
        height: 2px;
        background-color: ${ComplementaryColor.neonFresh};
    }

    &:hover {
        opacity: 0.8;
    }
`;

export const EAUpcomingCarouselWrapper = styled.div`
    background-color: ${BackgroundColor.elevated};
    padding: ${Spacer.SM};
    overflow-x: hidden;
    flex: 1;

    ${mediaMinWidth.sm} {
        padding: ${Spacer.SM} ${Spacer.S};
    }
`;

export const LastSeeAll = styled.a`
    display: flex;
    align-items: center;
    justify-content: center;
    height: 100%;
    position: relative;
    min-width: 160px;
    overflow: hidden;
    cursor: pointer;
`;

export const LastSeeAllImage = styled.img`
    position: absolute;
    max-width: 100%;
    width: auto;
    height: auto;
`;

export const LastSeeAllOverlay = styled.span`
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background-color: rgba(0, 0, 0, 0.5);
    z-index: 1;
`;

export const LastSeeAllButton = styled.span`
    z-index: 2;
    position: relative;

    /* Force white color for the button text */
    span {
        color: #ffffff !important;

        &::after {
            background-color: #ffffff;
        }
    }
`;
